import * as React from 'react';
import { SVGProps } from 'react';

const SvgMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 7.5A2.5 2.5 0 0 1 4.5 5h15C20.879 5 22 6.12 22 7.5v10c0 1.379-1.121 2.5-2.5 2.5h-15C3.12 20 2 18.879 2 17.5v-10Zm1.875 0v.863l6.738 5.532a2.18 2.18 0 0 0 2.774 0l6.738-5.532v-.898c0-.309-.281-.625-.625-.625h-15c-.345 0-.625.316-.625.625V7.5Zm0 3.29v6.71c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-6.71l-5.547 4.554c-1.5 1.23-3.656 1.23-5.191 0l-5.512-4.555Z"
      fill="#000"
    />
  </svg>
);

export default SvgMessage;
